import React from 'react';

function RewardsScreen() {
  return (
    <div className="container page page-rewards">
      <h1>Rewards</h1>
      <p>View your reward points and benefits here. (Placeholder)</p>
    </div>
  );
}

export default RewardsScreen;
